import { createContext } from 'react';

const LayoutContext = createContext<{ fullscreenComponentsHeight: string }>({ fullscreenComponentsHeight: '100vh' });

export default LayoutContext;
